import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { authenticationSelector } from '~/components/authentication/ducks/selectors';
import { selectIsoCodeForLocale, selectLocale, selectSportsbookMaintenanceEnabled } from '../../../brand/ducks';
import { AppDispatch } from '../../../../store/types';
import { selectFranchiseCode, selectHasProducts } from '../../../brand/ducks/selectors';
import {
	selectIsBettingServiceApiReady,
	refreshBettingServiceClient,
	setupAndConnectToBettingService,
	disposeAndDisconnectFromBettingService
} from '../api/sportsbook-api-duck';

const useInitializeBettingService = () => {
	const dispatch: AppDispatch = useDispatch();

	const locale = useSelector(selectLocale) as string;
	const franchiseCode = useSelector(selectFranchiseCode);
	const localeCode = useSelector(selectIsoCodeForLocale) as string;
	const isPlayerAuthenticated = useSelector(authenticationSelector);
	const { hasSportsbook, hasLivebetting } = useSelector(selectHasProducts);
	const showMaintenance = useSelector(selectSportsbookMaintenanceEnabled) as boolean;
	const isBettingServiceApiReady = useSelector(selectIsBettingServiceApiReady);

	const isBettingClientEnabled = (hasSportsbook || hasLivebetting) && !showMaintenance;

	useEffect(() => {
		dispatch(refreshBettingServiceClient(isBettingClientEnabled));
	}, [dispatch, isBettingClientEnabled, isPlayerAuthenticated]);

	useEffect(() => {
		dispatch(
			setupAndConnectToBettingService(
				{
					franchiseCode,
					locale,
					localeCode
				},
				isBettingClientEnabled
			)
		);

		return () => {
			dispatch(disposeAndDisconnectFromBettingService());
		};
	}, [isBettingClientEnabled, locale, franchiseCode, localeCode, dispatch]);

	return !isBettingClientEnabled || isBettingServiceApiReady;
};

export default useInitializeBettingService;
